import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"



	// eslint-disable-next-line
	
// name the component
	const __default__ = { name: 'TwTableRow' }

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		row: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})